import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'table-utilization-in-period',
	templateUrl: './table-utilization-in-period.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class TableUtilizationInPeriodComponent implements OnInit {
	
	@Input() generatedPreview: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.getReportSessionDescriptor = this.getReportSessionDescriptor;
	}
	
	getReportSessionDescriptor(type) {
		if (!!this.vm.generatedPreview && !!this.vm.generatedPreview.sessionsDescriptors) {
			return this.vm.generatedPreview.sessionsDescriptors.filter((descriptor) => {
				return descriptor.type === type;
			})[0];
		}
		return {};
	};
	
}